import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const ReplaceIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M8.56,8h5.83V9.21a1.07,1.07,0,0,0,.65,1A1,1,0,0,0,16.18,10l2.29-2.29a1,1,0,0,0,0-1.48l-2.29-2.3a1.05,1.05,0,0,0-1.79.74V5.87H8.56A5.64,5.64,0,0,0,2.93,11.5,1,1,0,1,0,5,11.5,3.55,3.55,0,0,1,8.56,8Z" />
      <path d="M20,12.75a1,1,0,0,0-1,1.05,3.54,3.54,0,0,1-3.54,3.53H9.61V16.09a1,1,0,0,0-1.79-.74l-2.3,2.29a1.06,1.06,0,0,0,0,1.48l2.3,2.29a1,1,0,0,0,.74.31,1.14,1.14,0,0,0,.4-.08,1,1,0,0,0,.65-1V19.43h5.83a5.64,5.64,0,0,0,5.63-5.63A1,1,0,0,0,20,12.75Z" />
    </SvgIcon>
  )
}
export default ReplaceIcon
